export const SORT_TYPE = {
  NameAsc: "name-asc",
  NameDesc: "name-desc",
  DateAsc: "date-asc",
  DateDesc: "date-desc",
  PinAsc: "pin-asc",
  PinDesc: "pin-desc",
};
